import classNames from 'classnames'
import type { ReactElement } from 'react'
import { Children, cloneElement } from 'react'
import { ChipVariant } from '../chip'
import styles from './ChipGroup.module.scss'
import type { ChipGroupProps } from './types'
import { ChipGroupVariant } from './types'

const ChipGroup = ({ children, className, variant = ChipGroupVariant.primary }: ChipGroupProps) => {
  const groupVariant =
    variant === ChipGroupVariant.primary ? ChipVariant.contrast : ChipVariant.primary

  const childrens = Children.toArray(children)
  childrens.forEach((child) => {
    if (child?.type?.displayName !== 'Chip') {
      // eslint-disable-next-line
      console.error('[Pintxo] ChipGroup only accepts Chip components as children')
    }
  })

  return (
    <div className={classNames(styles['pintxo-chip-group'], className)} data-variant={variant}>
      {Children.toArray(children)
        .filter(Boolean)
        .map((child, index) =>
          cloneElement(child as ReactElement, { variant: groupVariant, key: index })
        )}
    </div>
  )
}

export default ChipGroup
